import React from "react";
import login from "../../Assets/brand/login.svg";

const ResetPasswordIllustration: React.FC = () => {
  return (
    <div id="reset-password-illustration-container" className="max-w-md">
      <img
        id="reset-password-illustration-image"
        src={login}
        alt="Reset password illustration"
        className="w-full h-auto"
      />
    </div>
  );
};

export default ResetPasswordIllustration;
